import { QueryClient } from "@tanstack/react-query";
import { ApiClientError } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Retrying a refusal is pointless and, for a stale write, actively wrong —
        // the user has to decide whether to reapply their change.
        if (error instanceof ApiClientError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
